import { useEffect, useState } from "react";
import { Loader2, Ticket } from "lucide-react";
import api, { formatMoney } from "../lib/apiClient";

const RANGES = [
  { id: 30, label: "30d" },
  { id: 90, label: "90d" },
  { id: 36500, label: "All" },
];

export function CouponReport() {
  const [days, setDays] = useState(90);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    setLoading(true);
    api.get("/admin/coupons/report", { params: { days } })
      .then((r) => { if (active) setData(r.data); })
      .catch(() => { if (active) setData(null); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [days]);

  const codes = data?.codes || [];

  return (
    <div className="card-soft rounded-2xl p-6 mb-6" data-testid="coupon-report-card">
      <div className="flex items-center justify-between gap-4 mb-4 flex-wrap">
        <div className="flex items-center gap-3">
          <div className="rounded-2xl p-3 bg-gradient-to-br from-[#f4e7c4] to-[#e6c665]/50 ring-1 ring-[#e6c665]/40">
            <Ticket className="h-6 w-6 text-[#8a681c]" aria-hidden="true" />
          </div>
          <div>
            <h3 className="font-display font-bold text-lg">Referral Code Usage</h3>
            <p className="text-sm text-muted-foreground mt-0.5">Paid orders by coupon / athlete code.</p>
          </div>
        </div>
        <div className="flex gap-1 rounded-full bg-secondary p-1">
          {RANGES.map((r) => (
            <button
              key={r.id}
              onClick={() => setDays(r.id)}
              data-testid={`coupon-report-range-${r.id}`}
              className={`px-3 py-1 rounded-full text-xs font-semibold transition-colors ${days === r.id ? "bg-white shadow text-foreground" : "text-muted-foreground"}`}
            >
              {r.label}
            </button>
          ))}
        </div>
      </div>
      {loading ? (
        <div className="py-8 text-center text-muted-foreground"><Loader2 className="w-5 h-5 animate-spin inline" aria-hidden="true" /></div>
      ) : codes.length === 0 ? (
        <p className="py-6 text-center text-sm text-muted-foreground" data-testid="coupon-report-empty">No referral codes used in paid orders yet.</p>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm" data-testid="coupon-report-table">
            <thead>
              <tr className="text-left text-xs uppercase tracking-wide text-muted-foreground border-b border-border">
                <th className="py-2 pr-3">Code</th>
                <th className="py-2 px-3 text-right">Orders</th>
                <th className="py-2 px-3 text-right">Revenue</th>
                <th className="py-2 pl-3 text-right">Discount given</th>
              </tr>
            </thead>
            <tbody>
              {codes.map((c) => (
                <tr key={c.code} className="border-b border-border/50" data-testid={`coupon-report-row-${c.code}`}>
                  <td className="py-2 pr-3 font-semibold">{c.code}</td>
                  <td className="py-2 px-3 text-right" data-testid={`coupon-report-orders-${c.code}`}>{c.orders}</td>
                  <td className="py-2 px-3 text-right">{formatMoney(c.revenue)}</td>
                  <td className="py-2 pl-3 text-right text-[#8a681c]">−{formatMoney(c.discount)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
